// <Can> — permission-gated rendering (B5B §2.2). UI affordance ONLY; row-level access
// is enforced server-side by RLS (B5B §2.4). PLAN-C4.0 task-2.
import { type ReactNode } from "react";
import { hasPermission, type PermissionCode } from "@sympllex/auth";
import { useSession } from "./session";

export function Can({ perm, children, fallback = null }: { perm: PermissionCode; children: ReactNode; fallback?: ReactNode }) {
  const session = useSession();
  return <>{hasPermission(session, perm) ? children : fallback}</>;
}
